module.exports = __webpack_public_path__ + "static/the-collected-poems-of-audre-lorde-4ad19886fbc22bb63b3cc6999573bea0.jpg";